import { render } from "./ImageComponent.vue?vue&type=template&id=7c324fd9&ts=true"
import script from "./ImageComponent.vue?vue&type=script&lang=ts"
export * from "./ImageComponent.vue?vue&type=script&lang=ts"

import "./ImageComponent.vue?vue&type=style&index=0&id=7c324fd9&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__